import React, { forwardRef } from "react";
import classes from './DatePicker.module.scss';
import { DatePicker as AntDatePicker } from "antd";

const DatePicker = forwardRef(function DatePicker({ placeholder, className, ...props }, ref) {
  return (
    <AntDatePicker
      ref={ref}
      className={`${classes.input} ${className}`}
      placeholder={placeholder}
      {...props}
    />
  )
});

export default DatePicker;
